var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.1758C8.28333 12.1758 8.10417 12.1049 7.9625 11.9633C7.82083 11.8216 7.75 11.6424 7.75 11.4258V2.90078L5.275 5.37578C5.125 5.52578 4.95 5.59661 4.75 5.58828C4.55 5.57995 4.375 5.50078 4.225 5.35078C4.075 5.20078 4 5.02161 4 4.81328C4 4.60495 4.075 4.42578 4.225 4.27578L7.975 0.525781C8.05833 0.442448 8.14167 0.384114 8.225 0.350781C8.30833 0.317448 8.4 0.300781 8.5 0.300781C8.6 0.300781 8.69167 0.317448 8.775 0.350781C8.85833 0.384114 8.94167 0.442448 9.025 0.525781L12.8 4.30078C12.95 4.45078 13.025 4.62578 13.025 4.82578C13.025 5.02578 12.95 5.20078 12.8 5.35078C12.65 5.50078 12.4708 5.57578 12.2625 5.57578C12.0542 5.57578 11.875 5.50078 11.725 5.35078L9.25 2.90078V11.4258C9.25 11.6424 9.17917 11.8216 9.0375 11.9633C8.89583 12.1049 8.71667 12.1758 8.5 12.1758ZM2 16.0008C1.6 16.0008 1.25 15.8508 0.95 15.5508C0.65 15.2508 0.5 14.9008 0.5 14.5008V11.6758C0.5 11.4591 0.570833 11.2799 0.7125 11.1383C0.854167 10.9966 1.03333 10.9258 1.25 10.9258C1.46667 10.9258 1.64583 10.9966 1.7875 11.1383C1.92917 11.2799 2 11.4591 2 11.6758V14.5008H15V11.6758C15 11.4591 15.0708 11.2799 15.2125 11.1383C15.3542 10.9966 15.5333 10.9258 15.75 10.9258C15.9667 10.9258 16.1458 10.9966 16.2875 11.1383C16.4292 11.2799 16.5 11.4591 16.5 11.6758V14.5008C16.5 14.9008 16.35 15.2508 16.05 15.5508C15.75 15.8508 15.4 16.0008 15 16.0008H2Z",
    fill: "#858585"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.a3f9a403d273298a025dd364cc6d9d0e.svg";
export { ForwardRef as ReactComponent };